import './insuranceDetailsComponent.scss'
import React, {useCallback, useState} from 'react';
import Grid from '@mui/material/Grid';
import DetailsDataKeyValueComponent from "../details-data-key-value-component/detailsDataKeyValueComponent";
import ButtonComponent from "../core/button/ButtonComponent";
import DialogComponent from "../dialog/dialogComponent";
import FilePreviewerComponent from "../file-previewer/filePreviewerComponent";
import ChipComponent from '../chip/ChipComponent';
import {AttachFile} from '@mui/icons-material';
import CommonService from "../../services/common.service";
import commonService from "../../services/common.service";

interface InsuranceDetailsComponentProps {
    insuranceDetails: any;
    isAttachmentDownloadable?: boolean;
}

const InsuranceDetailsComponent = (props: InsuranceDetailsComponentProps) => {

    const {insuranceDetails, isAttachmentDownloadable} = props;
    const [showAttachmentPreviewDialog, setShowAttachmentPreviewDialog] = useState<boolean>(false);
    const [currentAttachmentUrl, setCurrentAttachmentUrl] = useState<string>("");
    const [currentAttachmentField, setCurrentAttachmentField] = useState<any>("");

    const handleAttachmentPreviewOpen = useCallback((fieldName: any) => {
        setCurrentAttachmentUrl(insuranceDetails[fieldName].attachmentUrl);
        fieldName === 'frontImage' ? setCurrentAttachmentField('Insurance Card Front') : setCurrentAttachmentField('Insurance Card Back')
        setShowAttachmentPreviewDialog(true);
    }, [insuranceDetails]);

    const handleAttachmentDialogClose = useCallback(() => {
        setShowAttachmentPreviewDialog(false);
    }, []);

    return (
        <div className='insurance-list-display'>
            <DetailsDataKeyValueComponent
                title={"Insurance Company"}> {insuranceDetails?.insuranceCompany || 'N/A'} </DetailsDataKeyValueComponent>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"First Name"}> {insuranceDetails?.firstName || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Last Name"}> {insuranceDetails?.lastName || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Relationship"}> {insuranceDetails?.relationship || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Payor ID"}> {insuranceDetails?.payerId || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Network/Plan Name"}> {insuranceDetails?.networkPlanName || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Group Name"}> {insuranceDetails?.groupName || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Group/Network"}> {insuranceDetails?.groupNetwork || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Clearing House"}> {insuranceDetails?.clearingHouse || 'N/A'} </DetailsDataKeyValueComponent>

                    <div className='insurance-attachments'>
                        <div className='insurance-attachments-header'>
                            Insurance Card Front
                        </div>
                        <div className='insurance-attachments-front-image'>
                            {insuranceDetails['frontImage']?.attachmentUrl ?
                                <ChipComponent
                                    onClick={() => {
                                        handleAttachmentPreviewOpen("frontImage");
                                    }}
                                    label={'Insurance Card Front'}
                                    icon={<AttachFile/>}
                                />
                                :
                                <div>Image Not Available</div>
                            }
                        </div>
                    </div>

                </Grid>
                <Grid item xs={12} sm={12} md={6} xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Middle Name"}> {insuranceDetails?.middleName || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Date Of Birth"}> {insuranceDetails?.dateOfBirth ? commonService.formatDate(insuranceDetails?.dateOfBirth) : 'N/A'} </DetailsDataKeyValueComponent>

                    <DetailsDataKeyValueComponent
                        title={"Policy Number"}> {insuranceDetails?.policyNumber || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Effective Date"}> {insuranceDetails?.effectiveDate ? commonService.formatDate(insuranceDetails?.effectiveDate) : 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"IPA/Medical Group Name"}> {insuranceDetails?.ipaMedicalGroupName || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent title={"EnB"}>
                        {/*{insuranceDetails?.enbotDetails?.isVerified === true*/}
                        {/*? "Verified"*/}
                        {/*: insuranceDetails?.enbotDetails?.isVerified === false*/}
                        {/*    ? "Not Verified"*/}
                        {/*    : "-"}*/}
                        {"-"}
                    </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"CPID"}> {insuranceDetails?.CPID || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Insurance Type"}> {insuranceDetails?.type || 'N/A'} </DetailsDataKeyValueComponent>

                    <div className='insurance-attachments'>
                        <div className='insurance-attachments-header'>
                            Insurance Card Back
                        </div>
                        <div className='insurance-attachments-back-image'>
                            {insuranceDetails['backImage']?.attachmentUrl ?
                                <ChipComponent
                                    onClick={() => {
                                        handleAttachmentPreviewOpen("backImage");
                                    }}
                                    label={'Insurance Card Back'}
                                    icon={<AttachFile/>}
                                /> :
                                <div>Image Not Available</div>
                            }
                        </div>
                    </div>
                </Grid>
            </Grid>

            <DialogComponent open={showAttachmentPreviewDialog}
                             maxWidth={'sm'}
                             onClose={() => {
                                 setShowAttachmentPreviewDialog(false)
                             }}
                             isShowCancel={true}
                             title={currentAttachmentField}
                             className={"attachment-preview-dialog"}>
                <div className="attachment-preview-dialog-body" id="file_preview_component">
                    <FilePreviewerComponent
                        attachmentUrl={currentAttachmentUrl}
                        isFile={false}/>
                </div>
                <div className="attachment-preview-dialog-footer">
                    <ButtonComponent variant={"outlined"}
                                     id="cancel_btn"
                                     fullWidth={true}
                                     handleClick={handleAttachmentDialogClose}>
                        Close
                    </ButtonComponent>&nbsp;
                    {
                        isAttachmentDownloadable &&
                        <ButtonComponent variant={"contained"}
                                         id="cancel_btn"
                                         className={"mrg-left-15"}
                                         fullWidth={true}
                                         handleClick={() => CommonService.downloadFile(currentAttachmentUrl, currentAttachmentField)}>
                            Download
                        </ButtonComponent>
                    }
                </div>
            </DialogComponent>

        </div>
    )
}
export default InsuranceDetailsComponent;
